var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-view__placeholder",style:({
    height: _vm.placeholderHeight + 'px',
    width: _vm.placeholderWidth + 'px',
  })},[(_vm.includeGroupBy)?_c('div',{staticClass:"grid-view__placeholder-groups",style:({ width: _vm.groupByWidth + 'px' })}):_vm._e(),_vm._v(" "),(_vm.includeRowDetails || _vm.visibleFields.length > 0)?_vm._l((_vm.placeholderPositions),function(value,index){return _c('div',{key:'placeholder-column-' + index,staticClass:"grid-view__placeholder-column",style:({ left: value - 1 + 'px' })})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }